<div class="error-msg error-text-size">
    {{ errorMsg }}
  </div>
